{
    "ChannelCode": "Code",
    "Components": {
        "MeetingEnd": {
            "FeedbackConfirmation": {
                "ExploreMoreFeatures": "Explore more features",
                "ThanksMessage": "Thanks for joining,",
                "WorkingMessage": "we hope translation made the event better for you."
            },
            "FeedbackForm": {
                "FeedbackQuestion": "How was the translation quality?",
                "SessionClosedMessage": "The live translation has ended.",
                "ThankYouMessage": "We hope this helped!"
            }
        }
    },
    "Continue": "Continue",
    "Control": {
        "Original": "Original",
        "Spacing": "Spacing",
        "TextSize": "Text-size",
        "Tts": "TTS"
    },
    "Download": "Download",
    "Idle": "Idle",
    "Join": "Join",
    "LanguageSettings": "Language",
    "Live": "Live",
    "Loading": {
        "Entering": "Entering channel",
        "Joining": "Joining channel"
    },
    "OK": "OK",
    "Pages": {
        "Home": {
            "EnterEventCodeMessage": "Please enter the channel code.",
            "InputPlaceholder": "Enter channel code",
            "Title": "Be there. Understand everything."
        },
        "SelectLanguage": {
            "SearchEmpty": "No matching language",
            "SearchPlaceholder": "Search language",
            "Title": "Choose your translation language"
        }
    },
    "Pane": {
        "CatchUp": "Go to Latest",
        "Source": "Original",
        "Translation": "Translation",
        "Tts": "Text to Speech",
        "TtsShort": "TTS"
    },
    "Share": "Share",
    "SpeechSpeed": "Speech Speed",
    "Start": "Start",
    "Submit": "Submit",
    "Tips": {
        "Error": {
            "Channel": {
                "LimitExceeded": "This channel has reached its connection limit."
            }
        },
        "Icon": {
            "ScrollToBottom": "Back to latest",
            "ShareLink": "Share link",
            "SpeechRate": "Set playback speed"
        }
    },
    "Toast": {
        "LanguageChanged": "Translation language: {lang}",
        "LinkCopied": "Link copied",
        "SourceOff": "Original hidden",
        "SourceOn": "Original shown",
        "TtsOff": "Speech off",
        "TtsOn": "Speech on"
    },
    "Transcript": {
        "Start": "Beginning of transcript"
    },
    "tutorialPage": {
        "downloadOverlay": {
            "originText": "Origin Text",
            "summary": "Summary",
            "transcript": "Transcripts"
        },
        "translationLanguage": {
            "title": "Translation language"
        }
    }
}
